import request from "@/utils/request";

// 浏览器只提交固定日志键；真实路径只保存在各服务器的后端配置中。
const baseUrl = "/sys/serverLog";

export function getServerLogFiles() {
  return request({
    url: baseUrl + "/files",
    method: "get",
  });
}

export function readServerLog(data) {
  return request({
    url: baseUrl + "/read",
    method: "post",
    data,
  });
}
